import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiltersChannel } from '../../../../../filters/models/filters-channel.model';
import { ITileInstance } from '../../../../interfaces/tiles/definition-helpers/tile-definition.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-filters-info-tile',
  templateUrl: './filters-info-tile.component.html',
  styleUrls: ['./filters-info-tile.component.scss'],
})
export class FiltersInfoTileComponent implements OnInit, OnDestroy {
  @Input() tileInstance: ITileInstance;
  @Input() filtersChannel: FiltersChannel;

  filtersJson: string;

  private readonly unsubscribe$ = new Subject<void>();

  ngOnInit() {
    this.filtersChannel?.filters.pipe(takeUntil(this.unsubscribe$)).subscribe((filters) => {
      this.filtersJson = JSON.stringify(filters, null, 4);
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
